// ═══════════════════════════════════════════════════════════
//  نسخة بدون Node.js — كل شيء في المتصفح (localStorage) + api.php
//  للذكاء الاصطناعي. تعمل على cPanel كملفات ثابتة + PHP.
// ═══════════════════════════════════════════════════════════

const USER_KEY = 'jadhr_user';
const LOGS_KEY = 'jadhr_logs';

// رابط ملف PHP (نفس النطاق)
const PHP_API = (process.env.PUBLIC_URL || '') + '/api.php';

function readUser() {
  try { return JSON.parse(localStorage.getItem(USER_KEY) || 'null'); } catch { return null; }
}
function writeUser(u) {
  localStorage.setItem(USER_KEY, JSON.stringify(u));
}
function readLogs() {
  try { return JSON.parse(localStorage.getItem(LOGS_KEY) || '[]'); } catch { return []; }
}
function writeLogs(l) {
  localStorage.setItem(LOGS_KEY, JSON.stringify(l));
}

// ── المصادقة (محلية بالكامل) ──
export const authAPI = {
  // لا يوجد تسجيل دخول — التطبيق يبدأ مباشرة من الـ Onboarding
  login: () => Promise.reject(new Error('login غير مستخدم في النسخة المحلية')),

  me: () => {
    const user = readUser();
    if (!user) return Promise.reject(new Error('لا يوجد مستخدم'));
    return Promise.resolve({ data: { user, subscription: null } });
  },

  completeOnboarding: (data) => {
    const user = { ...data, id: 1, onboarding_done: 1 };
    writeUser(user);
    return Promise.resolve({ data: { success: true } });
  },
};

// ── التحليل (يستدعي api.php) ──
export const analysisAPI = {
  analyze: async ({ numbers_seen = [], custom_numbers = [], user_state = '' }) => {
    const user = readUser() || {};
    const numbers = [...numbers_seen, ...custom_numbers];

    const concerns = Array.isArray(user.concerns) ? user.concerns.join('، ') : (user.concerns || '');

    const res = await fetch(PHP_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: user.name || 'صاحب الجذر',
        root_number: user.root_number || 1,
        personal_year: user.personal_year || '',
        concerns,
        relationship_status: user.relationship_status || '',
        numbers,
        state: user_state,
      }),
    });

    const data = await res.json();
    if (data.error) {
      const e = new Error(data.error);
      e.response = { data: { message: data.error } };
      throw e;
    }

    // احفظ في السجل المحلي
    const logs = readLogs();
    logs.unshift({
      id: Date.now(),
      log_date: new Date().toLocaleDateString('ar'),
      log_time: new Date().toLocaleTimeString('ar', { hour: '2-digit', minute: '2-digit' }),
      numbers_seen: JSON.stringify(numbers),
      user_state,
      ai_response: data.response,
    });
    if (logs.length > 60) logs.pop();
    writeLogs(logs);

    return { data: { success: true, response: data.response, source: data.source, sources: data.sources || [] } };
  },
};

// ── السجل (محلي) ──
export const logAPI = {
  getAll: () => Promise.resolve({ data: { logs: readLogs() } }),
  delete: (id) => {
    writeLogs(readLogs().filter((l) => l.id !== id));
    return Promise.resolve({ data: { success: true } });
  },
};

export default { authAPI, analysisAPI, logAPI };
